import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import { getProviderAvilableBalance } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Spinner from "../../Spin/Spinner";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";

const ProviderWalletAvilableBalance = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getProviderWalletData = async () => {
    setLoading(true);
    try {
      const response = await getProviderAvilableBalance(token, currentPage);
      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) getProviderWalletData();
  }, [currentPage, token]);

  const columns = [
    {
      header: "Provider Name",
      accessor: "providerName",
      render: (row) => row.providerName || "-",
    },
    {
      header: "Org Name",
      accessor: "orgName",
      render: (row) => row.orgName || "-",
    },
    {
      header: "Available Balance",
      accessor: "balance",
      render: (row) => Number(row.balance || 0).toFixed(2),
    },
    {
      header: "Created At",
      render: (row) => <DateCell date={row.createdAt} showTime />,
    },
    {
      header: "Updated At",
      render: (row) => <DateCell date={row.updatedAt} showTime />,
    },
  ];

  return (
    <div className="settlement-report-container">
      <div className="settlement-report-excel">
        <div className="settlement-report-title">
          Provider Available Balance
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : (
        <DataTable
          columns={columns}
          data={tableData.data || []}
          emptyMessage="No Data Found"
        />
      )}

      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default ProviderWalletAvilableBalance;